import { jsx as _jsx } from "react/jsx-runtime";
const logos = {
    filadd: {
        open: {
            src: "https://static.filadd.com/new-identity/logo/filadd_negative.svg",
            width: 91,
            height: 27,
        },
        closed: {
            src: "https://i.ibb.co/J2x6z03/Logo-filadd-chico.png",
            width: 38,
            height: 27,
        },
        alt: "Filadd",
    },
    kuadro: {
        open: {
            src: "https://static.filadd.com/public/kuadro/logo/logo-png-kuadro-transp.png",
            width: 50,
            height: 27,
        },
        closed: {
            src: "https://static.filadd.com/public/kuadro/logo/logo-png-kuadro-transp.png",
            width: 50,
            height: 27,
        },
        alt: "Kuadro",
    },
};
export const Logo = ({ open }) => {
    const theme = (process.env.THEME || "filadd");
    return (_jsx("a", { href: "/", children: open ? (_jsx("img", Object.assign({}, logos[theme].open, { alt: logos[theme].alt }))) : (_jsx("img", Object.assign({}, logos[theme].closed, { alt: logos[theme].alt }))) }));
};
//# sourceMappingURL=Logo.js.map